(function($) {
  
 $(document).ready(function(){
   
   $(".charms_in .m-menu-one-link").on('touchstart click', function(e){
      e.preventDefault();
      
      var h = $(this).next('.m-menu-two').height(); 
      
      
      if($(this).parent().attr('id')=="refine1_mobile"){
        $('#dragItem').css('margin-top','210px');	
      }else{
        $('#dragItem').css('margin-top','175px');	
      }
      	
    
      $(".charms_in .m-menu-two").css({
        'left': '200%'
      });
      
      $(this).next('.m-menu-two').css({
        'left': '100%'
      });

      $(".charms_in .m-menu-one").css({
        'position': 'absolute',
        'left': '-100%'
      });
      
      $(".charms_in .mobile-menu").css({ 
        '-webkit-transition': '.7s',
        'transition': '.7s',
        'height': h
      });
    });



    $(".charms_in .m-menu-back-one").on('touchstart click', function(e){
      e.preventDefault();
      
      var h = $(".charms_in .m-menu-one").height();
      var h = 86;
      $('#dragItem').css('margin-top','113px');
      $('.charms_in .m-menu-two').css({
        'position': 'absolute',
        'left': '100%'
      });

      $(".charms_in .m-menu-one").css({
        'left': '0',
        'position': 'relative'
      });
      
      $(".charms_in .mobile-menu").css({
        'height': h,
        '-webkit-transition': '.7s',
        'transition': '.7s'
      });

    });
 
 
 });
})(jQuery);




